import { UC_URL_PARAMS_APPID_AES_KEY, UC_URL_PARAMS_APPID_PREFIX } from '../../constants/ucAccount';
import XORCipher from '../XORCipher';

function decodeAppId(data) {
  var value = XORCipher.decode(UC_URL_PARAMS_APPID_AES_KEY, data);

  if (value.indexOf(UC_URL_PARAMS_APPID_PREFIX) === 0) {
    return value.replace(UC_URL_PARAMS_APPID_PREFIX, '');
  }

  return '';
}

export default decodeAppId;